// import React, { useState, useRef } from "react";
// import style from "./UploadInvoice.module.css";
// import MenuBar from "./MenuBar";
// import * as XLSX from "xlsx";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { API_BASE_URL } from "./config.js";

// const requiredColumns = [
//   "ItemCode",
//   "Quantity",
//   "Price",
//   "SrNoOfPO",
//   "PONo",
//   "InvoiceNo",
//   "InvoiceDate",
// ];

// const UploadInvoice = () => {
//   const [fileName, setFileName] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [fileData, setFileData] = useState(null);
//   const [groupedData, setGroupedData] = useState([]);
//   const [results, setResults] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fileInputRef = useRef(null);

//   const resetFile = () => {
//     setSelectedFile(null);
//     setFileName("");
//     setFileData(null);
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     setGroupedData([]);
//     setResults([]);
//     setFileData(null);

//     if (file?.name.endsWith(".xlsx")) {
//       setSelectedFile(file);
//       setFileName(file.name);
//     } else {
//       toast.error("Please select a valid .xlsx file.");
//       resetFile();
//     }
//   };

//   const handleDownloadTemplate = () => {
//     const worksheet = XLSX.utils.aoa_to_sheet([requiredColumns]);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
//     XLSX.writeFile(workbook, "InvoiceTemplate.xlsx");
//   };

//   const handleUpload = () => {
//     if (!selectedFile) {
//       toast.error("Please select a file before uploading.");
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const workbook = XLSX.read(e.target.result, { type: "array" });
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//       if (!jsonData?.length) {
//         toast.error("The file is empty.");
//         return;
//       }

//       const headers = jsonData[0].map((h) => h?.toString().trim());
//       const missing = requiredColumns.filter((col) => !headers.includes(col));
//       if (missing.length) {
//         toast.error("Missing required columns: " + missing.join(", "));
//         return;
//       }

//       const jsonResult = jsonData.slice(1).map((row) =>
//         headers.reduce((obj, header, i) => {
//           obj[header] = row[i] ?? "";
//           return obj;
//         }, {})
//       );

//       const grouped = Object.values(
//         jsonResult.reduce((acc, row) => {
//           const key = row.InvoiceNo;
//           if (!acc[key]) acc[key] = { InvoiceNo: row.InvoiceNo, items: [] };
//           acc[key].items.push(row);
//           return acc;
//         }, {})
//       );

//       setGroupedData(grouped);
//       toast.success("Data loaded & grouped! Please confirm.");
//     };

//     reader.readAsArrayBuffer(selectedFile);
//   };

//   const handleProceed = async () => {
//     try {
//       setLoading(true);
//       const sessionData = JSON.parse(sessionStorage.getItem("vendordata"));
//       const cardCode = sessionData?.CardCode || "";

//       const payload = groupedData.map((invoice) => ({
//         ...invoice,
//         CardCode: cardCode,
//       }));

//       console.log("Payload for API:", payload);

//       const response = await axios.post(
//         `${API_BASE_URL}/DraftGRPO/upload`,
//         payload
//       );

//       setResults(response.data);
//       toast.success("Data submitted successfully!");
//     } catch (error) {
//       console.error("Error submitting data:", error);
//       toast.error("Failed to submit data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={style.PurchaseOrderDetails}>
//       <div className={style.PurchaseOrderDetailsContainer}>
//         {/* <div className={style.MenuBarContainer}>
//           <MenuBar />
//         </div> */}

//         <div className={style.MainPurchaseOrderDetailsContainer}>
//           {/* <div className={style.MenuNameDetails}>Upload Invoice</div> */}

//           {groupedData.length === 0 && (
//             <div>
//               <div className={style.noteBox}>
//                 <ol>
//                   <li>
//                     Your xlsx data should be in the format below. The first line
//                     of your xlsx file should be the column headers as in the
//                     table example.
//                   </li>
//                   <li>
//                     If the column you are trying to import is date make sure
//                     that is formatted in format <b>Y-m-d (2024-12-20)</b>.
//                   </li>
//                 </ol>
//               </div>
//               <div className={style.samplearea}>
//                 <button
//                   onClick={handleDownloadTemplate}
//                   className={style.VerifyButton}
//                 >
//                   Download Sample (Export)
//                 </button>
//               </div>
//               <table className={style.DataTable}>
//                 <thead>
//                   <tr>
//                     {requiredColumns.map((col, i) => (
//                       <th key={i}>{col}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     {requiredColumns.map((col, i) => (
//                       <td key={i}></td>
//                     ))}
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           )}

//           <div className={style.Datearea}>
//             <input
//               type="file"
//               accept=".xlsx"
//               ref={fileInputRef}
//               className={style.FileInput}
//               onChange={handleFileChange}
//               onClick={(e) => (e.target.value = null)}
//             />

//             <button
//               onClick={handleUpload}
//               className={style.UploadButton}
//               disabled={!selectedFile}
//             >
//               Simulate Import
//             </button>
//           </div>

//           {groupedData.length > 0 && (
//             <div className={style.FileContent}>
//               <div className={style.MenuNameDetails}>Grouped Data</div>

//               {groupedData.map((group, idx) => (
//                 <div key={idx} className={style.GroupContainer}>
//                   <div className={style.InvoiceNoDetails}>
//                     InvoiceNo: {group.InvoiceNo}
//                   </div>
//                   <div className={style.UploadInvoicetable}>
//                     <table>
//                       <thead>
//                         <tr>
//                           {Object.keys(group.items[0]).map((header, i) => (
//                             <th key={i}>{header}</th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {group.items.map((item, rIdx) => (
//                           <tr key={rIdx}>
//                             {Object.values(item).map((val, cIdx) => (
//                               <td key={cIdx}>{val}</td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               ))}

//               {loading ? (
//                 <button className={style.VerifyButton} disabled>
//                   Processing...
//                 </button>
//               ) : (
//                 <button onClick={handleProceed} className={style.VerifyButton}>
//                   Proceed
//                 </button>
//               )}

//               {results.length > 0 && (
//                 <div className={style.ResultsContainer}>
//                   <div className={style.MenuNameDetails}>Upload Results</div>
//                   <table className={style.DataTable}>
//                     <thead>
//                       <tr>
//                         <th>InvoiceNo</th>
//                         <th>Message</th>
//                         <th>DraftEntry</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {results.map((res, i) => (
//                         <tr key={i}>
//                           <td>{res.InvoiceNo}</td>
//                           <td>{res.Message}</td>
//                           <td>{res.DraftEntry}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UploadInvoice;

import React, { useState, useRef } from "react";
import style from "./UploadInvoice.module.css";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "./config.js";

const requiredColumns = [
  "ItemCode",
  "Quantity",
  "Price",
  "SrNoOfPO",
  "PONo",
  "InvoiceNo",
  "InvoiceDate",
];

const UploadInvoice = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [groupedData, setGroupedData] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const resetFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setGroupedData([]);
    setResults([]);

    if (file?.name.endsWith(".xlsx")) {
      setSelectedFile(file);
    } else {
      toast.error("Please select a valid .xlsx file.");
      resetFile();
    }
  };

  const handleDownloadTemplate = () => {
    const worksheet = XLSX.utils.aoa_to_sheet([requiredColumns]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
    XLSX.writeFile(workbook, "InvoiceTemplate.xlsx");
  };

  const handleUpload = () => {
    if (!selectedFile) {
      toast.error("Please select a file before uploading.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      if (!jsonData?.length) {
        toast.error("The file is empty.");
        return;
      }

      const headers = jsonData[0].map((h) => h?.toString().trim());
      const missing = requiredColumns.filter((col) => !headers.includes(col));

      if (missing.length) {
        toast.error("Missing required columns: " + missing.join(", "));
        return;
      }

      const rows = jsonData.slice(1).map((row) =>
        headers.reduce((obj, header, i) => {
          obj[header] = row[i] ?? "";
          return obj;
        }, {})
      );

      const grouped = Object.values(
        rows.reduce((acc, row) => {
          const key = row.InvoiceNo;
          if (!acc[key]) acc[key] = { InvoiceNo: row.InvoiceNo, items: [] };
          acc[key].items.push(row);
          return acc;
        }, {})
      );

      setGroupedData(grouped);
      toast.success("Data loaded & grouped! Please confirm.");
    };

    reader.readAsArrayBuffer(selectedFile);
  };

  const handleProceed = async () => {
    try {
      setLoading(true);
      const sessionData = JSON.parse(sessionStorage.getItem("vendordata"));
      const cardCode = sessionData?.CardCode || "";

      const payload = groupedData.map((invoice) => ({
        ...invoice,
        CardCode: cardCode,
      }));

      const response = await axios.post(
        `${API_BASE_URL}/DraftGRPO/upload`,
        payload
      );

      setResults(response.data);
      toast.success("Data submitted successfully!");
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={style.PurchaseOrderDetails}>
      <div className={style.PurchaseOrderDetailsContainer}>
        <div className={style.MainPurchaseOrderDetailsContainer}>
          {groupedData.length === 0 && (
            <div>
              <div className={style.noteBox}>
                <ol>
                  <li>
                    First row must contain column headers exactly as shown.
                  </li>
                  <li>
                    For date fields use format <b>YYYY-MM-DD</b>.
                  </li>
                </ol>
              </div>

              <div className={style.samplearea}>
                <button
                  onClick={handleDownloadTemplate}
                  className={style.VerifyButton}
                >
                  Download Sample (Export)
                </button>
              </div>

              <table className={style.DataTable}>
                <thead>
                  <tr>
                    {requiredColumns.map((col, i) => (
                      <td key={i}>{col}</td>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {requiredColumns.map((_, i) => (
                      <td key={i}></td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          <div className={style.Datearea}>
            <input
              type="file"
              accept=".xlsx"
              ref={fileInputRef}
              className={style.FileInput}
              onChange={handleFileChange}
              onClick={(e) => (e.target.value = null)}
            />

            <button
              onClick={handleUpload}
              className={style.UploadButton}
              disabled={!selectedFile}
            >
              Simulate Import
            </button>
          </div>

          {groupedData.length > 0 && (
            <div className={style.FileContent}>
              <div className={style.MenuNameDetails}>Grouped Data</div>

              {groupedData.map((group, idx) => (
                <div key={idx} className={style.GroupContainer}>
                  <div className={style.InvoiceNoDetails}>
                    InvoiceNo: {group.InvoiceNo}
                  </div>

                  <div className={style.UploadInvoicetable}>
                    <table>
                      <thead>
                        <tr>
                          {Object.keys(group.items[0]).map((header, i) => (
                            <td key={i}>{header}</td>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {group.items.map((item, rIdx) => (
                          <tr key={rIdx}>
                            {Object.values(item).map((val, cIdx) => (
                              <td key={cIdx}>{val}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}

              {loading ? (
                <button className={style.VerifyButton} disabled>
                  Processing...
                </button>
              ) : (
                <button onClick={handleProceed} className={style.VerifyButton}>
                  Proceed
                </button>
              )}

              {results.length > 0 && (
                <div className={style.ResultsContainer}>
                  <div className={style.MenuNameDetails}>Upload Results</div>

                  <table className={style.DataTable}>
                    <thead>
                      <tr>
                        <th>InvoiceNo</th>
                        <th>Message</th>
                        <th>DraftEntry</th>
                      </tr>
                    </thead>

                    <tbody>
                      {results.map((res, i) => (
                        <tr key={i}>
                          <td>{res.InvoiceNo}</td>
                          <td>{res.Message}</td>
                          <td>{res.DraftEntry}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadInvoice;
